import { render } from "./sponsorsForm.vue?vue&type=template&id=14935e72"
import script from "./sponsorsForm.vue?vue&type=script&lang=js"
export * from "./sponsorsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__